import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="your_trade-in" clip-path="url(#clip0_1426_4897)">
        <g id="Mask group">
          <mask id="mask0_1426_4897" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="2" width="23" height="23">
            <g id="Group">
              <path id="Vector" d="M22.8059 2.35034H0.165283V24.9982H22.8131V2.35034H22.8059Z" fill="white" />
            </g>
          </mask>
          <g mask="url(#mask0_1426_4897)">
            <g id="Group_2">
              <path
                id="Vector_2"
                d="M22.813 17.4728H8.76866V19.8375C8.76866 19.9956 8.73272 20.1466 8.64647 20.2831C8.56022 20.4125 8.43804 20.5203 8.29429 20.5778C8.19685 20.6205 8.09161 20.6425 7.98522 20.6425C7.93491 20.6425 7.8846 20.6425 7.83429 20.6281C7.67616 20.5994 7.5396 20.5203 7.4246 20.4125L1.79679 14.8853C1.65304 14.7344 1.57397 14.5331 1.57397 14.3319C1.57397 14.1306 1.65304 13.9294 1.79679 13.7784L7.4246 8.25124C7.5396 8.14343 7.67616 8.06437 7.83429 8.03562L7.98522 8.02124C8.09161 8.02119 8.19685 8.04322 8.29429 8.08593C8.43804 8.15062 8.56022 8.25124 8.64647 8.38062C8.73272 8.50999 8.76866 8.66812 8.76866 8.82624V11.3706H22.813V17.4872V17.4728Z"
                fill="#5586D4"
              />
              <path
                id="Vector_3"
                d="M17.1565 6.20286L13.3975 2.5013C13.11 2.20661 12.8009 2.40067 12.8009 2.87505V4.49942H0.165283V8.5388H5.3906L6.46872 7.47505C6.75622 7.18755 7.1156 6.99349 7.5181 6.91442C7.64747 6.89286 7.77685 6.87849 7.90622 6.87849C8.17935 6.87849 8.44528 6.9288 8.69685 7.0438C9.0706 7.20192 9.38685 7.46786 9.60966 7.80567C9.75341 8.03567 9.84685 8.28005 9.89716 8.5388H12.8153V10.2782C12.8153 10.7525 13.074 10.9538 13.4118 10.6591L17.1709 6.95755C17.2931 6.86411 17.3147 6.71317 17.3147 6.5838C17.3147 6.45442 17.2787 6.33224 17.1781 6.22442L17.1637 6.21005L17.1565 6.20286Z"
                fill="#1F3E74"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1426_4897">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
